'use client';
import React from 'react';
import Link from 'next/link';
import {
  Bot,
  Globe,
  Share2,
  Search,
  FileText,
  Image as ImageIcon,
  Video,
  FileSpreadsheet,
  Zap,
  Server,
} from 'lucide-react';

export const TTOSEverythingGrid: React.FC = () => {
  const tools = [
    {
      title: 'AI Business Manager',
      desc: 'Your personal AI manager that recommends, plans and executes for you.',
      icon: Bot,
      color: 'text-purple-600 bg-purple-50',
    },
    {
      title: 'AI Website Builder',
      desc: 'Build professional websites with AI in minutes. No coding.',
      icon: Globe,
      color: 'text-blue-600 bg-blue-50',
    },
    {
      title: 'AI Social Media',
      desc: 'Create, schedule and publish content across all social platforms.',
      icon: Share2,
      color: 'text-pink-600 bg-pink-50',
    },
    {
      title: 'AI SEO Suite',
      desc: 'Find keywords, optimize content and rank higher on Google.',
      icon: Search,
      color: 'text-emerald-600 bg-emerald-50',
    },
    {
      title: 'AI Content Studio',
      desc: 'Generate blogs, articles, captions, ads and more with AI.',
      icon: FileText,
      color: 'text-indigo-600 bg-indigo-50',
    },
    {
      title: 'AI Images',
      desc: 'Create stunning images for social media, ads, blogs and websites.',
      icon: ImageIcon,
      color: 'text-amber-600 bg-amber-50',
    },
    {
      title: 'AI Videos',
      desc: 'Generate engaging videos, reels and shorts in minutes.',
      icon: Video,
      color: 'text-purple-600 bg-purple-50',
    },
    {
      title: 'Business Tools',
      desc: 'Invoices, proposals, QR, calculators, forms and 30+ business tools.',
      icon: FileSpreadsheet,
      color: 'text-teal-600 bg-teal-50',
    },
    {
      title: 'Automation',
      desc: 'Automate repetitive tasks, follow-ups, posting and marketing.',
      icon: Zap,
      color: 'text-rose-600 bg-rose-50',
    },
    {
      title: 'Hosting & Domains',
      desc: 'Get hosting, domains, SSL, server and website maintenance.',
      icon: Server,
      color: 'text-cyan-600 bg-cyan-50',
    },
  ];

  return (
    <section id="everything" className="py-16 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading (Matching Screenshot 3 exactly) */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            Everything You Need. All in One Platform.
          </h2>
        </div>

        {/* 10 Tools Grid (5x2 on desktop, matching screenshot) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3.5">
          {tools.map((tool, idx) => (
            <div
              key={idx}
              className="p-4 rounded-2xl bg-white border border-slate-200/90 shadow-xs hover:border-indigo-300 hover:shadow-md transition-all duration-200 flex flex-col items-start text-left group"
            >
              {/* Soft Colored Square Icon */}
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 shadow-xs transition-transform group-hover:scale-105 ${tool.color}`}
              >
                <tool.icon className="w-5 h-5" />
              </div>

              {/* Tool Title */}
              <h3 className="text-xs font-bold text-slate-900 group-hover:text-indigo-600 transition-colors">
                {tool.title}
              </h3>

              {/* Tool Description */}
              <p className="text-[11px] text-slate-500 mt-1 leading-relaxed">
                {tool.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TTOSEverythingGrid;
